<template>
  <div id="StopsStep">
    <v-card elevation="1" class="pa-1 pt-0">
      <div class="d-flex pa-2 pt-1 list-container">
        <v-card class="column pa-1">
          <div class="d-flex justify-space-between align-center column-title px-3">
            <div class="d-flex align-center">
              <h1 style="color: black">Entregas</h1>
              <v-divider v-show="!isCollapsed" vertical class="mx-2 my-1"></v-divider>
              <span v-show="!isCollapsed" class="mb-0 mt-1 font-weight-medium caption mr-2"
                >{{ filteredUnallocatedDeliveries.length }} itens</span
              >
              <v-tooltip right nudge-top="1">
                <template v-slot:activator="{ on, attrs }">
                  <div v-bind="attrs" v-on="on">
                    <v-checkbox
                      v-if="!isCollapsed"
                      v-model="selectAllDelivery"
                      :disabled="filteredUnallocatedDeliveries.length === 0"
                      class="custom-checkbox pa-0 ma-0"
                      hide-details
                      @change="toggleSelectAllDeliveries"
                    ></v-checkbox>
                  </div>
                </template>
                <span>Selecionar todas</span>
              </v-tooltip>
            </div>
            <div class="d-flex align-center">
              <span v-if="filteredUnallocatedDeliveries.length > 0">
                <v-tooltip v-if="!isCollapsed" right>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon v-bind="attrs" v-on="on" class="ml-3" @click="isCollapsed = !isCollapsed"
                      >mdi-chevron-double-left</v-icon
                    >
                  </template>
                  <span>Recolher</span>
                </v-tooltip>
                <v-tooltip v-else right>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon v-bind="attrs" v-on="on" @click="isCollapsed = !isCollapsed">
                      mdi-chevron-double-right
                    </v-icon>
                  </template>
                  <span>Expandir</span>
                </v-tooltip>
              </span>
            </div>
          </div>
          <div v-if="isCollapsed" class="d-flex justify-space-between align-center px-3">
            <v-checkbox
              v-model="selectAllDelivery"
              label="Selecionar todas"
              :disabled="filteredUnallocatedDeliveries.length === 0"
              class="custom-checkbox collapsed pa-0 ma-0"
              hide-details
              @change="toggleSelectAllDeliveries"
            ></v-checkbox>
            <v-divider vertical class="mx-1 my-1"></v-divider>
            <span class="mb-0 font-weight-medium caption">{{ filteredUnallocatedDeliveries.length }} itens</span>
          </div>
          <v-divider class="mx-2 my-1"></v-divider>
          <v-text-field
            v-show="!isCollapsed"
            class="custom-search px-2"
            label="Buscar"
            color="black"
            prepend-inner-icon="mdi-magnify"
            outlined
            dense
            single-line
            v-model="searchQueryUnallocated"
            @keydown.enter="performSearch('unallocated')"
            @click:prepend-inner="performSearch('unallocated')"
          ></v-text-field>
          <div v-if="isUnallocatedLoading" class="px-2">
            <v-progress-linear indeterminate />
          </div>
          <div
            class="deliveries-container pa-2 pt-0 justify-center"
            :style="{ height: isCollapsed ? '540px' : '530px', width: isCollapsed ? '240px' : '370px' }"
          >
            <drag-card-deliveries
              :deliveries="filteredUnallocatedDeliveries"
              :selectedDeliveries="selectedDelivery"
              :isCollapsed="isCollapsed"
              @update:selected="updateDeliverySelection"
              @update:selectedDeliveries="selectedDelivery = $event"
              @update:selectAll="selectAllDelivery = $event"
            />
          </div>
        </v-card>
        <div class="w-100 column pa-1">
          <div class="d-flex justify-space-between align-center column-title px-3">
            <div class="d-flex align-center">
              <h1 style="color: black">Paradas</h1>
              <v-divider vertical class="mx-2 my-1"></v-divider>
              <v-label class="pb-0 pt-1 mr-2 font-weight-medium black--text" style="font-size: 14px"
                >{{ filteredStops.length }} itens</v-label
              >
              <v-checkbox
                v-model="selectAllStops"
                label="Selecionar todas"
                :disabled="filteredStops.length === 0"
                class="custom-checkbox collapsed pa-0 ma-0 mt-1"
                hide-details
                @change="toggleSelectAllStops"
              />
            </div>
          </div>
          <v-divider class="mx-2 my-1"></v-divider>
          <v-text-field
            v-show="stops.length > 0"
            class="custom-search px-2"
            label="Buscar"
            color="black"
            prepend-inner-icon="mdi-magnify"
            outlined
            dense
            single-line
            v-model="searchQueryStops"
            @keydown.enter="performSearch('stops')"
            @click:prepend-inner="performSearch('stops')"
          ></v-text-field>
          <div v-if="isStopsLoading" class="px-2">
            <v-progress-linear indeterminate />
          </div>
          <div v-if="!stops.length > 0" class="selected-container d-flex align-center justify-center rounded mb-2">
            <v-icon size="60" color="" style="padding-bottom: 3px">mdi-emoticon-neutral-outline</v-icon>
            <div class="d-flex flex-column ml-2">
              <span class="text-h5">Nenhuma parada criada até o momento.</span>
              <span class="text-subtitle-1 font-weight-regular">
                Crie uma
                <a
                  class="new-import-delivery text-decoration-underline"
                  target="_blank"
                  rel="noopener noreferrer"
                  @click="addStop()"
                  >nova parada</a
                >
                para prosseguir.
              </span>
            </div>
          </div>
          <div class="d-flex justify-center align-center py-3" v-else-if="filteredStops.length == 0">
            Nenhuma parada encontrada
          </div>
          <div class="stop-container" v-else>
            <StopHierarchy
              ref="StopHierarchy"
              v-for="item in virtualStopsList"
              :stop="item"
              :selected="selectedStops[item.id]"
              :key="item.id"
              @update:selected="updateStopSelection"
              @update:selectAll="selectAllStops = $event"
              @input="item.alocatedDeliveries = $event"
              @update:allocated="updateUnallocated"
              @removeStop="removeStop(item.id)"
            />
            <div v-if="filteredStops.length" v-observe-visibility="handleStopsScroll"></div>
          </div>
          <div class="px-2 mt-2"></div>
        </div>
      </div>
    </v-card>
    <confirm-dialog
      :isOpen="isOpenConfirmationComputed || isOpenConfirmDeleteComputed"
      @confirmClick="confirmClick"
      :title="titleConfirmation"
      @cancelClick="cancel"
      :body-text="bodyText"
    />
    <MessagesError :errors="errors" :type="errorsType" :error500="error500" @closeMessages="errors = []" />
  </div>
</template>

<script>
import DragCardDeliveries from '@/components/ManualBoardingImport/Stepper/Step4/DragCardDeliveries.vue';
import StopHierarchy from '@/components/ManualBoardingImport/Stepper/Step4/StopHierarchy.vue';
import ConfirmDialog from '@/components/ConfirmDialog';
import MessagesError from '@/components/MessagesError.vue';
import { mapActions } from 'vuex';
import maskWeight from '@/utils/maskWeight';
import maskCPF from '@/utils/maskCPF';
import maskCNPJ from '@/utils/maskCNPJ';
export default {
  name: 'StopsStep',
  components: {
    DragCardDeliveries,
    StopHierarchy,
    ConfirmDialog,
    MessagesError
  },
  props: {
    isOpenConfirmation: {
      type: Boolean,
      default: false
    },
    isOpenConfirmDelete: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    isImportsLoading: false,
    isUnallocatedLoading: false,
    isStopsLoading: false,
    fileHeaders: [
      {
        value: 'deliveryNumber',
        text: 'NÚMERO DE ENTREGA',
        sortable: true
      },
      {
        value: 'status',
        text: 'STATUS',
        sortable: true
      },
      {
        value: 'actions',
        align: 'end',
        text: 'AÇÕES',
        sortable: false
      }
    ],
    unallocatedDeliveries: [],
    stops: [],
    stopsToShow: 5,
    filteredUnallocatedDeliveries: [],
    filteredStops: [],
    selectAllDelivery: false,
    selectAllStops: false,
    selectedDelivery: {},
    selectedStops: {},
    searchQueryUnallocated: '',
    searchQueryStops: '',
    isCollapsed: true,
    isCteDialogOpen: false,
    trashItem: null,
    errors: [],
    errorsType: 'error',
    error500: null
  }),
  mounted() {
    this.fetchUnallocatedDeliveries();
    this.fetchStops();
    this.checkAndEmit();
  },
  watch: {
    stops: {
      handler() {
        this.checkAndEmit();
      }
    },
    unallocatedDeliveries: {
      handler() {
        this.checkAndEmit();
      }
    },
    filteredUnallocatedDeliveries: {
      handler() {
        this.selectAllDelivery ? this.toggleSelectAllDeliveries() : this.updateSelectAllDeliveries();
      }
    },
    filteredStops: {
      handler() {
        this.selectAllStops ? this.toggleSelectAllStops() : this.updateSelectAllStops();
      }
    },
    searchQueryUnallocated: {
      handler(value) {
        if (value === '') {
          this.filteredUnallocatedDeliveries = this.unallocatedDeliveries;
        }
      }
    },
    searchQueryStops: {
      handler(value) {
        if (value === '') {
          this.filteredStops = this.stops;
        }
      }
    },
    selectedStops: {
      handler() {
        this.$emit('selectedStopsIds', this.selectedStopsIds);
      }
    }
  },
  computed: {
    parameterID() {
      return this.$route.params.id;
    },
    isOpenConfirmationComputed: {
      get() {
        return this.isOpenConfirmation;
      },
      set(value) {
        this.$emit('update:isOpenConfirmation', value);
      }
    },
    isOpenConfirmDeleteComputed: {
      get() {
        return this.isOpenConfirmDelete;
      },
      set(value) {
        this.$emit('update:isOpenConfirmDelete', value);
      }
    },
    selectedDeliveriesIds() {
      return Object.keys(this.selectedDelivery).filter((id) => this.selectedDelivery[id]);
    },
    selectedStopsIds() {
      return Object.keys(this.selectedStops).filter((id) => this.selectedStops[id]);
    },
    virtualStopsList() {
      return this.filteredStops.slice(0, this.stopsToShow);
    },
    titleConfirmation() {
      if (this.isOpenConfirmDeleteComputed) {
        return 'Desfazer Paradas';
      } else {
        return 'Confirmar paradas criadas';
      }
    },
    bodyText() {
      if (this.isOpenConfirmDeleteComputed) {
        const selectedDeliveries = this.stops.filter((cte) => this.selectedStopsIds.includes(cte.id));
        const numbers = selectedDeliveries.map((nfe) => nfe.stopNumber);
        return `Confirmar dasalocar as entregas relacionadas e o descarte das paradas:${numbers.slice(0, 15)}${
          numbers.length > 15 ? '...' : ''
        }?`;
      } else {
        return `Você confirma os dados das ${this.stops.length} parada(s)?`;
      }
    }
  },
  methods: {
    ...mapActions('ImportManualStopsStore', [
      'getAllUnallocatedDeliveries',
      'getAllStops',
      'createNewStop',
      'createGroupedStops',
      'deleteStop',
      'deleteMultipleStops'
    ]),

    async fetchUnallocatedDeliveries() {
      try {
        this.isUnallocatedLoading = true;
        const data = await this.getAllUnallocatedDeliveries(this.parameterID);
        this.unallocatedDeliveries = data;
        this.filteredUnallocatedDeliveries = data;
        await this.filterDeliveries();
      } catch (err) {
        console.error(err);
      } finally {
        this.isUnallocatedLoading = false;
      }
    },

    async fetchStops() {
      try {
        this.isStopsLoading = true;
        const data = await this.getAllStops(this.parameterID);
        this.stops = data;
        this.filteredStops = data;
        await this.filterStops();
      } catch (err) {
        console.error(err);
      } finally {
        this.isStopsLoading = false;
      }
    },
    async createStop() {
      this.$emit('isCreateStopLoading', true);
      try {
        await this.createNewStop(this.parameterID);
      } catch (err) {
        console.error(err);
      } finally {
        this.$emit('isCreateStopLoading', false);
      }
    },
    async automaticGroupedStops() {
      this.$emit('isAutomaticGroupedLoading', true);
      try {
        const model = {
          processId: this.parameterID,
          deliveriesIds: this.selectedDeliveriesIds
        };
        const response = await this.createGroupedStops(model);
        if (response.success) {
          this.errors = ['Agrupamento realizado com sucesso!'];
          this.errorsType = 'success';
          this.selectedDelivery = {};
          this.selectAllDelivery = false;
        } else {
          this.errors = response.errors || ['Erro ao Agrupar Entregas'];
          this.errorsType = 'error';
        }
        this.fetchUnallocatedDeliveries();
        this.fetchStops();
        await this.checkAndEmit();
      } catch (err) {
        console.error(err);
      } finally {
        this.$emit('isAutomaticGroupedLoading', false);
      }
    },
    async removeStop(id = null, multi = false) {
      try {
        const response = multi ? await this.deleteMultipleStops(this.selectedStopsIds) : await this.deleteStop(id);
        if (response.success) {
          this.errors = [`${multi ? 'Paradas deletadas' : 'Parada deletada'} com sucesso!`];
          this.errorsType = 'success';
          this.selectedStops = {};
        } else {
          this.errors = response.errors || ['Erro ao deletar Parada'];
          this.errorsType = 'error';
        }
        this.fetchUnallocatedDeliveries();
        this.fetchStops();
        setTimeout(() => {
          this.checkAndEmit();
        }, 100);
      } catch (err) {
        console.error(err);
      } finally {
        this.isUnallocatedLoading = false;
      }
    },
    async addStop(automaticGrouping = false) {
      if (!automaticGrouping) {
        await this.createStop();
        await this.fetchStops();
        await this.checkAndEmit();
      } else {
        await this.automaticGroupedStops();
      }
    },

    toggleSelectAllDeliveries() {
      this.selectedDelivery = {};
      this.filteredUnallocatedDeliveries.forEach((delivery) => {
        this.$set(this.selectedDelivery, delivery.id, this.selectAllDelivery);
      });

      this.updateSelectAllDeliveries();
    },
    updateDeliverySelection(id) {
      this.$set(this.selectedDelivery, id, !this.selectedDelivery[id]);
      this.updateSelectAllDeliveries();
      this.checkAndEmit();
    },
    updateSelectAllDeliveries() {
      this.selectAllDelivery =
        this.filteredUnallocatedDeliveries.length > 0
          ? this.filteredUnallocatedDeliveries.every((delivery) => this.selectedDelivery[delivery.id])
          : false;
      this.checkAndEmit();
    },
    toggleSelectAllStops() {
      this.selectedStops = {};
      this.filteredStops.forEach((stop) => {
        this.$set(this.selectedStops, stop.id, this.selectAllStops);
      });
      this.updateSelectAllStops();
    },
    updateSelectAllStops() {
      this.selectAllStops =
        this.filteredStops.length > 0 ? this.filteredStops.every((stop) => this.selectedStops[stop.id]) : false;
      this.$emit('selectedStopsIds', this.selectedStopsIds);
      this.checkAndEmit();
    },
    updateStopSelection(id) {
      this.$set(this.selectedStops, id, !this.selectedStops[id]);
      this.updateSelectAllStops();
    },
    performSearch(type) {
      if (type === 'unallocated') {
        this.filterDeliveries();
      } else if (type === 'stops') {
        this.filterStops();
      }
    },
    filterDeliveries() {
      this.isUnallocatedLoading = true;
      const query = this.searchQueryUnallocated ? this.searchQueryUnallocated.toLowerCase() : '';
      const queryNormalized = query.replace(/[^\d]/g, '');
      if (query === '') {
        this.filteredUnallocatedDeliveries = this.unallocatedDeliveries;
      } else {
        const normalizeValue = (value) => (value ? value.replace(/[^\d]/g, '') : '');
        this.filteredUnallocatedDeliveries = this.unallocatedDeliveries.filter((delivery) => {
          return (
            (delivery.deliveryNumber && delivery.deliveryNumber.toString().toLowerCase().includes(query)) ||
            (delivery.nameSender && delivery.nameSender.toLowerCase().includes(query)) ||
            (delivery.cpfCnpjSender && this.transformCpfOrCnpj(delivery.cpfCnpjSender).toLowerCase().includes(query)) ||
            (delivery.nameRecipient && delivery.nameRecipient.toLowerCase().includes(query)) ||
            (delivery.cpfCnpjRecipient &&
              this.transformCpfOrCnpj(delivery.cpfCnpjRecipient).toLowerCase().includes(query)) ||
            (delivery.totalPriceNfes &&
              normalizeValue(maskWeight(delivery.totalPriceNfes)).includes(queryNormalized)) ||
            (delivery?.weightNfes && `${maskWeight(delivery?.weightNfes || 0)}kg`.toLowerCase().includes(query))
          );
        });
      }
      this.isUnallocatedLoading = false;
    },
    filterStops() {
      this.isStopsLoading = true;
      const query = this.searchQueryStops ? this.searchQueryStops.toLowerCase() : '';
      const queryNormalized = query.replace(/[^\d]/g, '');
      if (query === '') {
        this.filteredStops = this.stops;
      } else {
        const normalizeValue = (value) => (value ? value.replace(/[^\d]/g, '') : '');
        this.filteredStops = this.stops.filter((stop) => {
          return (
            (stop.stopNumber && stop.stopNumber.toString().toLowerCase().includes(query)) ||
            (stop.nameRecipient && stop.nameRecipient.toLowerCase().includes(query)) ||
            (stop.nameCityRecipient && stop.nameCityRecipient.toLowerCase().includes(query)) ||
            (stop.cpfCnpjRecipient && stop.cpfCnpjRecipient.toLowerCase().includes(query)) ||
            (stop.totalPriceNfes && normalizeValue(maskWeight(stop.totalPriceNfes)).includes(queryNormalized)) ||
            (stop.totalPriceDeliveries &&
              normalizeValue(maskWeight(stop.totalPriceDeliveries)).includes(queryNormalized)) ||
            (stop?.weightDeliveries && `${maskWeight(stop?.weightDeliveries || 0)}kg`.toLowerCase().includes(query)) ||
            (stop.amountDeliveries && stop.amountDeliveries.toString().toLowerCase().includes(query))
          );
        });
      }

      this.isStopsLoading = false;
    },
    cancel() {
      this.isOpenConfirmationComputed = false;
      this.isOpenConfirmDeleteComputed = false;
    },
    confirmClick() {
      if (this.isOpenConfirmDeleteComputed) {
        this.removeStop(null, this.selectedStopsIds);
        this.isOpenConfirmDeleteComputed = false;
      } else {
        this.$emit('confirmClick');
      }
    },
    checkAndEmit() {
      const hasStops = this.stops.length > 0;
      const hasStopsWithDeliveries = this.stops.some((cte) => cte.amountDeliveries > 0);
      const hasStopsWithoutDeliveries = this.stops.filter((cte) => cte.amountDeliveries == 0);
      let message = '';
      let errorValidate = false;
      if (!hasStops) {
        message = 'Crie pelo menos uma parada';
        errorValidate = true;
      } else if (!hasStopsWithDeliveries) {
        message = 'Nenhuma parada com entregas alocadas';
        errorValidate = true;
      } else if (hasStopsWithoutDeliveries.length > 0) {
        const numbers = hasStopsWithoutDeliveries.map((stop) => stop.stopNumber).join(', ');
        message = `Parada(s) de N° ${numbers} devem ter ao menos uma entrega alocada`;
        errorValidate = true;
      }
      this.$emit('step3Finished', errorValidate, message);

      message = '';
      errorValidate = false;
      if (this.unallocatedDeliveries.length === 0) {
        message = 'Nenhuma entrega disponível para agrupamento';
        errorValidate = true;
      } else if (this.selectedDeliveriesIds.length === 0) {
        message = 'Selecione as entregas para agrupar';
        errorValidate = true;
      }
      this.$emit('isDisabledAutomaticGrouped', message, errorValidate);
    },
    handleStopsScroll(isVisible) {
      if (!isVisible || this.stopsToShow >= this.filteredStops.length) return;
      this.stopsToShow += 5;
    },
    async updateUnallocated(msg, success) {
      if (success) {
        this.errors = [msg];
        this.errorsType = 'success';
        this.selectedDelivery = {};
        this.selectAllDelivery = false;
      } else {
        this.errors = [msg];
        this.errorsType = 'info';
      }
      await this.fetchUnallocatedDeliveries();
      if (this.unallocatedDeliveries.length === 0) {
        this.isCollapsed = true;
      }
      await this.fetchStops();
      this.checkAndEmit();
    },
    transformCpfOrCnpj(str) {
      if (str.length === 11) {
        return maskCPF(str);
      }

      return maskCNPJ(str);
    }
  }
};
</script>
<style lang="scss" scoped>
.list-container {
  width: 100%;
  height: 638px;
}

.selected-container {
  width: 100%;
  height: 520px;
}
.card-container {
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  gap: 1rem;
  width: 100%;
}
.stop-container {
  width: 100%;
  height: auto;
  max-height: 540px;
  overflow-y: auto;
  overflow-x: hidden;
}
.selected-card {
  box-shadow: 0 2px 4px rgba(23, 23, 23, 0.18);
  border: solid 1px #4299e1;
  color: #4299e1;
  h4,
  .v-icon path {
    color: #4299e1;
    fill: #4299e1;
  }
}
.column-title {
  width: 100%;
  text-align: left;
}

.deliveries-container {
  width: 100%;
  height: auto;
  overflow-y: auto;
  overflow-x: hidden;
}
.deliveries-container::-webkit-scrollbar,
.stop-container::-webkit-scrollbar {
  width: 8px;
  height: 5px;
  background-color: #f5f5f5;
}

.deliveries-container::-webkit-scrollbar-track,
.stop-container::-webkit-scrollbar-track {
  padding-left: 1px;
  padding-right: 1px;
  background-color: #f5f5f5;
}

.deliveries-container::-webkit-scrollbar-thumb,
.stop-container::-webkit-scrollbar-thumb {
  background-color: #999999;
  border-radius: 8px;
}
::v-deep .deliveries-container::-webkit-scrollbar-thumb:hover,
.stop-container::-webkit-scrollbar-thumb:hover {
  background-color: #0f426e9d;
}
.ghost-card {
  opacity: 0.5;
  background: #f7fafc;
  border: 1px solid #4299e1;
}
.icon {
  opacity: 0.5;
  background: #f7fafc;
  border: 1px solid #4299e1;
}
.new-import-delivery {
  color: #4299e1;
}
::v-deep .custom-checkbox .v-label {
  font-weight: 500;
  font-size: 14px;
  color: black;
}
::v-deep .v-input {
  input {
    max-height: 40px;
    .v-input__slot .v-input__prepend-inner {
      position: relative;
      top: 0px;
    }
  }
  .v-text-field {
    &__slot {
      margin: 0;
      padding: 0;

      input,
      textarea {
        border: none;
        border-radius: none;
        padding: 0 0px;
        box-shadow: none;
        background: none;

        &:focus,
        &:hover {
          background: none;
          border-color: none;
        }
      }

      .v-label {
        position: relative;
        transform: translateY(0px);
        top: auto;
        color: black;
      }
    }
  }
}

::v-deep .custom-checkbox .collapsed .v-input--selection-controls__input {
  margin-right: 0px;
}

.ghost {
  opacity: 0.5;
  background: #c8ebfb;
}
</style>
